export default {"src":"/_next/static/media/american-football.1b0faaca.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};